import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';
import humanize from 'underscore.string/humanize';
import underscored from 'underscore.string/underscored';

import classNames from 'classnames';

export default class CheckboxInput extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    style: PropTypes.object.isRequired
  };

  static defaultProps = {
    checked: false,
    disabled: false,
    className: null,
    style: {}
  };

  handleChange(e) {
    this.props.onChange(e.currentTarget.checked);
  }

  render() {
    let {
      name, children,
      style: userStyle, className, ...props
    } = this.props;
    children = children ? children : humanize(name);
    name = underscored(name);

    return (
      <span className={classNames(style.checkboxInput, className)}>
        <input
         id={name} name={name} {...props}
         onChange={this.handleChange.bind(this)}
         type="checkbox" />
        <label
         style={userStyle}
         htmlFor={name}>
          {children}
        </label>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/checkbox-input.js